// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"799":"9cc3fa7c","819":"6eca83eb","997":"9c1792ad"}[chunkId] + ".chunk.css";
};